import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	footer: {
		position: "fixed",
		bottom: 0,
		left: 0,
		width: "100%",
		height: 64,
		background: colors.gray[50],
		zIndex: 5000,
		borderTop: `1px solid ${colors.gray[200]}`,
		display: "flex",
		alignItems: "center"
	},

	menuWrapper: {
		display: "flex",
		width: "100%",
		justifyContent: "space-around",
		alignItems: "center"
	},

	menuItem: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		userSelect: "none",
		padding: theme.spacing(1, 2)
	},

	icon: {
		width: 26,
		height: 26,
		color: colors.gray[900]
	},

	label: {
		marginTop: 4,
		fontSize: 12,
		color: colors.gray[900],
		fontWeight: 500
	},

	fullScreenMenu: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		zIndex: 6000,
		background: colors.gray[50],
		display: "flex",
		flexDirection: "column"
	},

	menuHeader: {
		height: 56,
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 2)
	},

	closeBtn: {
		fontSize: 16,
		fontWeight: 600,
		cursor: "pointer",
		color: colors.gray[700]
	},

	menuContent: {
		padding: theme.spacing(2),
		display: "flex",
		flexDirection: "column",
		overflowY: "auto"
	},

	category: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2),
		cursor: "pointer",
		padding: theme.spacing(1.5),
		borderRadius: 8,
		"&:active": {
			background: colors.gray[200]
		}
	},

	categoryLabel: {
		fontSize: 16,
		fontWeight: 500,
		color: colors.gray[900]
	},
	subItem: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		cursor: "pointer",
		padding: "14px 12px",
		borderRadius: 8,
		"&:active":
			{
				background: colors.gray[200]
			}
	},

	subItemLabel: {
		fontSize: 15,
		fontWeight: 500,
		color: colors.gray[700]
	},

	backBtn: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		cursor: "pointer",
		fontSize: 16,
		fontWeight: 600,
		color: colors.gray[700]
	}
}))

export default useStyles
